import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useDeleteAffiliationMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const deleteAffiliation = async (id) => {
    const url = encodeURI(`${env.apiUrl}/affiliations/${id}`)
    const response = await securedFetch(url, { method: 'DELETE' })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ id }) => deleteAffiliation(id),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error deleting group'),
    onSuccess: () => {
      setMessage('Group was deleted')
      queryClient.invalidateQueries('affiliations')
      queryClient.invalidateQueries('admin-affiliations')
    },
    onSettled: progressEnd
  })
}

export { useDeleteAffiliationMutation }
